import { BsHeartFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="mx-auto grid w-full max-w-7xl gap-2 py-4 px-4">
      <div className="flex justify-between items-center">
        <div className="text-sm  text-slate-400 flex flex-row">
          {new Date().getFullYear()} &copy; Cobrief. Made with{" "}
          <BsHeartFill color="red" className="ml-1 mr-1 mt-1" /> in London.
        </div>
        <div className="text-sm  text-slate-400">
          <Link to="/terms" className="hover:underline mr-4 text-slate-400">
            Terms
          </Link>
          |
          <Link to="/privacy" className="ml-4 hover:underline text-slate-400">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
